import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModalDialogComponent } from '../modal-dialog/modal-dialog.component';
import { NgStyle } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-one-button-dialog',
    templateUrl: './one-button-dialog.component.html',
    styleUrls: ['./one-button-dialog.component.scss'],
    imports: [
        ModalDialogComponent,
        NgStyle,
        MatButton,
        TranslateModule,
    ],
})
export class OneButtonDialogComponent {
    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: {
            msg: string;
            headline: string;
            showCloseButton?: boolean;
            headlineFontSize?: number;
            headlineBold?: boolean;
            msgFontSize?: number;
            buttonFontSize?: number;
            buttonHeight?: number;
        },
        private dialogRef: MatDialogRef<OneButtonDialogComponent>
    ) {
        this.data.showCloseButton = this.data.showCloseButton ?? true;
    }

    close(): void {
        this.dialogRef.close();
    }
}
